import styled from "styled-components";

import "../../../GlobalStyles/Font.css";

export const ContainerNewTask = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin-left: auto;
  margin-right: auto;
  position: relative;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    margin-left: 0px;
    margin-right: 0px;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
    padding: 24px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
    left: 234px;
  }
`;

export const NoFoundTaskContainer = styled.div`
  display: flex;
  max-width: 100%;
  height: 192px;
  align-items: center;
  justify-content: center;
  padding: 16px;

  @media (min-width: 428px) {
    max-width: 396px;
    height: 212px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    height: 186px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
    height: 165px;
    margin-left: auto;
    margin-right: auto;
    padding: 0px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
    height: 240px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const NotAddedTaskContainer = styled.div`
  display: flex;
  max-width: 100%;
  height: 192px;
  align-items: center;
  justify-content: center;
  padding: 16px;

  @media (min-width: 428px) {
    max-width: 396px;
    height: 212px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    height: 186px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
    height: 165px;
    margin-left: auto;
    margin-right: auto;
    padding: 0px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
    height: 240px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const MessageNotAdd = styled.p`
  font-size: 20px;
  font-family: Exo2 SemiBold;

  @media (min-width: 1024px) {
    font-size: 24px;
  }
`;

export const MessageNotFound = styled.p`
  font-size: 20px;
  font-family: Exo2 SemiBold;

  @media (min-width: 1024px) {
    font-size: 24px;
  }
`;
